
<nav>
	<ul>
		<li
			class="social"
			*ngFor="
		      let social of socials; 
		    "

		>
			<a
				class="social-link"
				[routerLink]="social.url" 
				title="{{ social.title }}"
			>
				<lib-icon class="icon" name="{{ social.icon }}" [shadow]="true"></lib-icon>
			</a>
		</li>
	</ul>
</nav>
